import { useMemo, useState } from "react";

import { allDatasets } from "@/mocks/apis/dataset/data";
import { DatasetExploreItem } from "@/types/dataset";

import { DatasetCard } from "./DatasetCard";

export function AnalysisHistoryDatasetList() {
  const datasets: DatasetExploreItem[] = allDatasets;

  const [expandedIds, setExpandedIds] = useState<string[]>([]);

  const allExpanded = useMemo(
    () => expandedIds.length === datasets.length && datasets.length > 0,
    [expandedIds, datasets.length]
  );

  const handleExpandCollapse = (data: DatasetExploreItem) => {
    setExpandedIds((prev) =>
      prev.includes(data.id)
        ? prev.filter((id) => id !== data.id)
        : [...prev, data.id]
    );
  };

  const handleExpandAll = (expand: boolean) => {
    setExpandedIds(expand ? datasets.map((d) => d.id) : []);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-txtHeading font-semibold text-[14px]">Datasets</h3>
        <button
          className="text-primary-teal text-xs font-semibold hover:underline"
          onClick={() => handleExpandAll(!allExpanded)}
        >
          {allExpanded ? "Collapse All" : "Expand All"}
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 items-start gap-4">
        {datasets.map((item) => (
          <DatasetCard
            key={item.id}
            data={item}
            expanded={expandedIds.includes(item.id)}
            handleExpandCollapse={handleExpandCollapse}
          />
        ))}
      </div>
    </div>
  );
}
